// Import des fonctions nécessaires de Firebase
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getAnalytics } from "firebase/analytics";

// Configuration Firebase
const firebaseConfig = {
  apiKey: "AIzaSyCxuuuoYNGLGosbml0j4UwzrLrb8HWoK2U",
  authDomain: "mobilapp-3505a.firebaseapp.com",
  projectId: "mobilapp-3505a",
  storageBucket: "mobilapp-3505a.firebasestorage.app",
  messagingSenderId: "889059340192",
  appId: "1:889059340192:web:a9ce54df274601be3dfec5",
  measurementId: "G-0B4XWNFKHE"
};

// Initialiser Firebase
const app = initializeApp(firebaseConfig);

// Initialiser Firestore
const db = getFirestore(app);

// Initialiser Authentication
const auth = getAuth(app);

// Initialiser Analytics (uniquement en production)
let analytics = null;
if (process.env.NODE_ENV === 'production') {
  analytics = getAnalytics(app);
}

export { app, db, auth, analytics };
